import { Stack, Typography, Button, TextField, InputAdornment } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import { colors } from "./Pipeline.styles";

const PipelineHeader = ({ onAddLead, onFilter, pipelineType = null, searchValue = "", onSearchChange }) => {
  const theme = useTheme();
  // Determine title and subtitle based on pipelineType
  const getHeaderInfo = () => {
    if (pipelineType === "pre-consult") {
      return {
        title: "Pre-Consultation Pipeline",
        subtitle: "Track and manage qualified leads through pre-consultation",
      };
    }
    if (pipelineType === "post-consult") {
      return {
        title: "Post-Consultation Pipeline",
        subtitle: "Track and manage leads through post-consultation stages",
      };
    }
    return {
      title: "Lead Pipeline",
      subtitle: "Track and manage your leads through the sales pipeline",
    };
  };

  const headerInfo = getHeaderInfo();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        mb: 3,
        px: 0.5,
      }}
    >
      {/* Left: Title */}
      <Stack spacing={0.5}>
        <Typography
          sx={{
            fontSize: 25,
            fontWeight: 700,
            color: colors.textPrimary,
            lineHeight: 1.2,
          }}
        >
          {headerInfo.title}
        </Typography>
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 500,
            color: colors.textSecondary,
          }}
        >
          {headerInfo.subtitle}
        </Typography>
      </Stack>

      {/* Right: Actions */}
      <Stack direction="row" spacing={1.5} alignItems="center">
        {/* Search */}
        <TextField
          value={searchValue}
          onChange={(e) => onSearchChange?.(e.target.value)}
          placeholder="Search by name, phone, or source..."
          size="small"
          sx={{
            width: 240,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              bgcolor: "#fff",
              height: 38,
              fontSize: 13,
              "& fieldset": { borderColor: colors.border },
              "&:hover fieldset": { borderColor: "#CBD5E1" },
              "&.Mui-focused fieldset": { borderColor: theme.palette.primary.main },
            },
            "& .MuiOutlinedInput-input": {
              py: 0.75,
              "&::placeholder": { color: "#94A3B8", opacity: 1 },
            },
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#94A3B8", fontSize: 18 }} />
                </InputAdornment>
              ),
            },
          }}
        />

        {/* Filter Button */}
        <Button
          variant="outlined"
          startIcon={<FilterListIcon sx={{ fontSize: 18 }} />}
          onClick={onFilter}
          sx={{
            px: 2,
            py: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 14,
            borderColor: colors.border,
            color: colors.textPrimary,
            "&:hover": {
              borderColor: colors.primary,
              bgcolor: colors.bgPrimary,
            },
          }}
        >
          Filter
        </Button>

        {/* Add New Lead Button */}
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          onClick={onAddLead}
          sx={{
            px: 2.5,
            py: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 14,
            bgcolor: theme.palette.primary.main,
            color: "#FFFFFF",
            boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
            "&:hover": {
              bgcolor: theme.palette.primary.dark,
              boxShadow: `0 6px 16px ${theme.palette.primary.main}59`,
            },
          }}
        >
          Add New Lead
        </Button>
      </Stack>
    </Stack>
  );
};

export default PipelineHeader;
